<template>
  <v-row
    class="d-flex"
    justify="space-between"
    align="start"
    @click="$emit('selectProduct', product)"
  >
    <v-col cols="8">
      <div class="body-1">{{ product.name }}</div>
      <div
        :class="{
          caption: true,
          'grey--text': true,
          'text--darken-1': !isDark,
          'text--lighten-1': isDark,
          description: true
        }"
      >
        {{ product.description }}
      </div>
    </v-col>
    <v-col cols="3" class="text-right" align-self="start">
      <div class="d-flex flex-column justify-space-between">
        <div class="body-2 mb-2" v-if="product.price > 0">
          {{ localizedPrice }}
        </div>
        <div class="d-flex justify-end text-center">
          <v-btn icon>
            <v-icon class="d-flex justify-end text-center" color="primary">
              mdi-plus-circle-outline
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { Order, OrderProductStatus, OrderProduct } from "@/model/order";

export default {
  components: {},
  props: ["product"],
  data: function() {
    return {
      search: "",
      image:
        "http://imagenpng.com/wp-content/uploads/2016/09/starbucks-logo.png"
    };
  },
  methods: {
    addProduct(product) {
      let orderProductMap = {
        ...this.product,
        comment: "",
        status: "pending",
        options: []
      };
      let orderProduct = OrderProduct.fromMap(orderProductMap);

      this.$emit("addProduct", orderProduct);
    }
  },
  computed: {
    localizedPrice: function() {
      return parseFloat(this.product.price).toFixed(2) + " €";
    },
    isDark() {
      return window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
  }
};
</script>

<style scoped>
.description {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>
